import api from "./api"

export const getCustomers = async (params = {}) => {
  // Ensure params is always a valid object
  const validParams = params && typeof params === "object" ? params : {}

  // Get organizationId from user context if not provided
  if (!validParams.organizationId) {
    // Get current user from localStorage or context
    const user = JSON.parse(localStorage.getItem("user") || "{}")
    if (user && user.organizationId) {
      validParams.organizationId = user.organizationId
    }
  }

  const response = await api.get("/customers", { params: validParams })
  return response.data
}

export const getCustomer = async (id) => {
  try {
    if (!id) {
      throw new Error("Customer ID is required")
    }
    const response = await api.get(`/customers/${id}`)
    return response.data
  } catch (error) {
    console.error("Error fetching customer:", error)
    throw error
  }
}

export const createCustomer = async (customerData) => {
  // Get organizationId from user context if not provided
  if (!customerData.organizationId) {
    // Get current user from localStorage or context
    const user = JSON.parse(localStorage.getItem("user") || "{}")
    if (user && user.organizationId) {
      customerData.organizationId = user.organizationId
    }
  }

  const response = await api.post("/customers", customerData)
  return response.data
}

export const updateCustomer = async (id, customerData) => {
  const response = await api.put(`/customers/${id}`, customerData)
  return response.data
}

export const deleteCustomer = async (id) => {
  const response = await api.delete(`/customers/${id}`)
  return response.data
}

export const reactivateCustomer = async (id) => {
  const response = await api.patch(`/customers/${id}/reactivate`)
  return response.data
}

export const restoreCustomer = async (id) => {
  const response = await api.patch(`/customers/${id}/restore`)
  return response.data
}

export const searchCustomers = async (query) => {
  // Ensure query is a valid object
  const params = query && typeof query === "string" ? { query } : typeof query === "object" ? query : {}

  // Get organizationId from user context if not provided
  if (!params.organizationId) {
    // Get current user from localStorage or context
    const user = JSON.parse(localStorage.getItem("user") || "{}")
    if (user && user.organizationId) {
      params.organizationId = user.organizationId
    }
  }

  const response = await api.get(`/customers/search`, { params })
  return response.data
}

/**
 * Fetch paginated customers
 * @param {Object} params - { organizationId, page, limit }
 * @returns {Promise<Object>} { success, count, data, limit, page }
 */
export const getCustomersPaginated = async (params = {}) => {
  // Ensure params is always a valid object
  const validParams = params && typeof params === "object" ? params : {};

  // Get organizationId from user context if not provided
  if (!validParams.organizationId) {
    const user = JSON.parse(localStorage.getItem("user") || "{}")
    if (user && user.organizationId) {
      validParams.organizationId = user.organizationId
    }
  }

  const response = await api.get("/customers/paginated", { params: validParams });
  return response.data;
};

